import BaseGetters from '@/store/base/getters'
import DetailGetters from "@/store/base/detail/getters";
import DocumentsGetters from '@/store/base/documents/getters'

export default BaseGetters({
  getModelByUuid: state => uuid => state.module.find(el => el.uuid === uuid),
  getUnassignReasons: state => state.unassignReasons,
}, [DocumentsGetters, DetailGetters])